import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, EventEmitter, ViewChild } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { EmailManagerDetail as EmailManagerDetailUI } from "..//email-manager/email-manager.detail";
import { EmailTypeList } from '../email-type/email-type.list';
import { EmailManagerList } from './email-manager.list';
import { EmailManagerDetailHttpService } from '../../../services/http/administration/email-manager-detail.http.service';
import { EmailManagerHttpService } from '../../../services/http/administration/email-manager.http.service';
import { EmailTypeHttpService } from '../../../services/http/administration/email-type.http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EmailType } from '../../../model/api/administration/email-type';
import { AppState } from '../../../model/api/common/app-state';
import { EmailManager } from '../../../model/api/administration/email-manager';
import { EmailManagerDetail } from '../../../model/api/administration/email-manager-detail';
import { AppUtils } from '../../../common/app.utils';
import { AppStateHttpService } from '../../../services/http/common/app-state.http.service';

@Component({
    selector: 'email-manager-manage',
    templateUrl: 'email-manager.manage.html',
    styleUrls: ['email-manager.manage.scss'],
    providers: []
})
export class EmailManagerManage extends GenericManage<EmailManager, number> {

    @ViewChild('emailManagerDetailModal') emailManagerDetailModal: ModalDirective;
    @ViewChild('emailManagerList') emailManagerList: EmailManagerList;
    @ViewChild('emailManagerDetail') emailManagerDetail: EmailManagerDetailUI;
    @ViewChild('emailTypeListModal') emailTypeListModal: ModalDirective;
    @ViewChild('emailTypeList') emailTypeList: EmailTypeList;

    public filter: string = '';
    public selectedEmailType: EmailType = null;
    public selectedAppState: AppState = null;
    public appState: string = 'Status';
    public appStates: Array<AppState> = new Array<AppState>();

    constructor(public emailTypeHttpService: EmailTypeHttpService, public emailManagerHttpService: EmailManagerHttpService, public appStateHttpService: AppStateHttpService,
        public emailManagerDetailHttpService: EmailManagerDetailHttpService) {

        super();

        this.appStateHttpService.getDetailByParentCode('EMAILMANAGER').subscribe((res: any) => { this.appStates = res; });

    }

    public addNewItem() {
        super.addNewItem();

        this.emailManagerDetail.emailType = null;
    }

    public editItem() {
        super.editItem();

        let emailManager: EmailManagerDetail = this.selectedItem as EmailManagerDetail;

        this.emailManagerDetail.emailType = null;

        if (emailManager != null && emailManager.emailType != null) {
            this.emailTypeHttpService
                .getById(emailManager.emailType.id)
                .subscribe((emailType: EmailType) => {
                    this.emailManagerDetail.emailType = emailType;
                });
        }
    }

    public detailInitialize() {
        super.detailInitialize();
        this.emailManagerDetailModal.show();
    }

    public detailTerminate() {
        super.detailTerminate();
        this.emailManagerDetailModal.hide();
    }

    public onEmailManagerDetailEmailTypeNeeded() {
        this.emailManagerDetailModal.hide();
        this.selectEmailType();
    }

    public onEmailTypeListCancel() {
        this.emailTypeListModal.hide();
        if (this.viewMode === GenericManageViewMode.ItemDetail) {
            this.emailManagerDetailModal.show();
        }
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));
        params.push(new Param("emailTypeIds", AppUtils.getIdsList<EmailType, number>([ this.selectedEmailType ])));
        params.push(new Param("appStateIds", AppUtils.getIdsList<AppState, number>([ this.selectedAppState ])));

        this.emailManagerList.refresh(params);
    }

    public selectEmailType() {
        this.emailTypeListModal.show();
        this.emailTypeList.refresh(null);
    }

    public setSelectedEmailType() {
        switch(this.viewMode) {
            case GenericManageViewMode.ItemList:
                this.selectedEmailType = this.emailTypeList.selectedItem;
                this.emailTypeListModal.hide();
                this.refresh();
                break;
            case GenericManageViewMode.ItemDetail:
                this.emailManagerDetail.emailType = this.emailTypeList.selectedItem;
                this.emailTypeListModal.hide();
                this.emailManagerDetailModal.show();
                break;
        }
    }


    public unselectEmailType() {
        this.selectedEmailType = null;
        this.refresh();
    }

    public onAppStateUpdate(appStateId: number, appStateName: string) {
        if (appStateId !== -1) {
            this.selectedAppState = new AppState(appStateId, appStateName, appStateName, 'EMAILMANAGER');
        } else {
            this.selectedAppState = null;
        }

        this.appState = appStateName ;
        this.refresh();
    }

    public exportToExcel() {

         let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.emailManagerDetailHttpService.get(1, 1000000, 'id', 'asc', params, null).subscribe(
            (data: PagedResult<EmailManager>) => {

                let options = {
                    sheetid: 'emailManager',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // let res = alasql(`SELECT id as [Id]
                //                     INTO XLSX("emailManager.xlsx",?) FROM ?`,[ options, data.items ]);

            });
    }


    public accept() {
      if(confirm('Esti sigur ca vrei sa validezi oferta selectata?')){
        let id = this.selectedItem.id;
        this.emailManagerHttpService.accept(id).subscribe((res) => {
          if(res) {
            alert('Operatia a fost finalizata cu succes!');
            this.refresh();
          }
       });
      }


}

public decline() {
  if(confirm('Esti sigur ca vrei sa validezi oferta selectata?')){
    let id = this.selectedItem.id;
    this.emailManagerHttpService.decline(id).subscribe((res) => {
      if(res) {
        alert('Operatia a fost finalizata cu succes!');
        this.refresh();
      }
   });
  }

}
}
